<template>
  <a-form ref="advertisementForm" :model="form" layout="vertical" class="mt-10">
    <a-divider orientation="center">
      New User
    </a-divider>
    <a-row :gutter="20">
      <a-col :span="12">
        <a-form-item label="Email">
          <a-input v-model:value="form.email" placeholder="Email" />
        </a-form-item>
      </a-col>
      <a-col :span="12">
        <a-form-item label="Password">
          <a-input v-model:value="form.password" placeholder="Password" />
        </a-form-item>
      </a-col>
    </a-row>

    <a-row :gutter="20">
      <a-col :span="12">
        <a-form-item label="Business Type">
          <Select v-model="form.business_type" :options="userTypes" />
        </a-form-item>
      </a-col>

      <a-col :span="8">
        <a-form-item label="Plans">
          <Select v-model="form.plan" :options="plans" />
        </a-form-item>
      </a-col>
    </a-row>
  </a-form>
</template>

<script>
import Select from "@/components/UI/Select/index";

export default {
  components: { Select },
  props: {
    modelValue: Object,
    mediaType: String,
  },

  data() {
    return {
      isLoading: false,
      labelCol: { span: 5 },
      wrapperCol: { span: 16 },
      userTypes: [
        { label: "Agency", value: "agency" },
        { label: "Ecommerce", value: "ecommerce" },
        { label: "Other", value: "other" },
      ],
    };
  },
  computed: {
    form: {
      get() {
        return this.modelValue;
      },
      set(newValue) {
        this.$emit("update:modelValue", newValue);
      },
    },

    industries() {
      return this.$store.state.industries;
    },
    plans() {
      return this.$store.state.all_plans;
    },
  },
};
</script>

<style></style>
